import { Grid, useMediaQuery } from "@material-ui/core";
import { Children, FC } from "react";

import { GenericObject } from "../types/generic.types";

const Spacing: FC<SpacingProps> = ({
  containerStyle = { height: "auto" },
  itemStyle = { height: "auto" },
  children,
}) => {
  const getColsNum = (): any => 12 / Children.count(children);
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  return (
    <Grid container spacing={2} style={containerStyle}>
      {Children.map(children, (child) => (
        <Grid item xs={isSmall ? 12 : getColsNum()} style={itemStyle}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
};

interface SpacingProps {
  containerStyle?: GenericObject;
  itemStyle?: GenericObject;
}

export default Spacing;
